import product from './modules/product'

export default {
  product
}
